import React from 'react'
import { useLogin } from '../../../hooks/useUser'
import { useTranslation } from 'react-i18next'
import { ControllerInput } from '../../shared/Input/ControllerInput'
import { useInitUser } from '../../../hooks/useUser'
import { useAllowedCountries } from '../../../hooks/useRoutes'
import { RouterLink } from '../../shared/simple/RouterLink'
import { siteMap } from '../../../constants/routes'
import { Button } from '../../shared/simple/Button'
import { Label } from '../../shared/simple/Label'
import { isUndefinedNull } from '../../../helpers/shared'
import { useSelector } from 'react-redux'
import { FormProvider } from 'react-hook-form'
import SlideCaptchaModal from '../../shared/slide-captcha-modal/SlideCaptchaModal'
import { useOtpModal } from '../../../hooks/useOtpModal'
import OtpInputModal from '../../shared/otp-input-modal/OtpInputModal'
import { LoaderSpinner } from '../../shared/simple/LoaderSpinner'
import { Link } from '../../shared/simple/Link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarked } from '@fortawesome/free-solid-svg-icons'
import { StyledLogo } from '../styled'
import { useTheme } from '@mui/material'
import { useMediaQuery } from '@mui/material'
import AltRecoverPassword from './AltRecoverPassword'
import { 
  MainContainer, Content,
  SlideViewport, SlideTrack, SlidePanel
} from '../HomepageStarterEmail/styled' // Reuse previous component
import { LinkText } from '../../shared/simple/RouterLink'
import AltClientEntity from './AltClientEntity'
import { LinkLogo } from '../LinkLogo'
import { useNewProductRequestFromQueryParam } from '../../../hooks/useUser'

const AltLoginPage = () => {
  const { allowed } = useAllowedCountries();
  const {
    errors,
    handleSubmit,
    onGetStarted,
    onLogin,
    register,
    activateLocation,
    reset,
    methods,
    setValue, 
    getValues
  } = useLogin();
  const { t } = useTranslation()
  const { loading, onSubmit, isSlideModalOpen, setIsSlideModalOpen, values } = useInitUser(allowed)
  const { geolocation, deviceInfo } = useSelector(state => state.base)
  const { selectedProduct } = useSelector(state => state.user);
  // ? For the new product request for RRHH, using query params
  useNewProductRequestFromQueryParam()
  
  const altErrorMessageStyle = {
    display: 'block',
    color: '#FF7171',
    backgroundColor: 'rgba(255, 113, 113, 0.12)',
    borderLeft: '3px solid #FF7171',
    padding: '2px 8px',
    borderRadius: '6px',
    fontSize: '0.875em',
    fontWeight: 500,
    marginTop: '2px',
    marginBotton: '0px',
    width: 'fit-content',
    textAlign: 'left',
    position: 'absolute'
  }; 
  const { isOpen, handleClose, handleOpen, otpValues, attemps, setAttemps } = useOtpModal({ setValue, getValues })
  const responsiveTheme = useTheme();
  const isMobile = useMediaQuery(responsiveTheme.breakpoints.down('md'));

  // * Logic for multistep
  const [step, setStep] = React.useState(1)
  const [slidesNumber] = React.useState(3)
  const onForgotPassword = () => {
    setStep(2)
  }

  // ? For hiding to the user the fact that we scroll to the middle step during the first render
  const [motionTransition, setMotionTransition] = React.useState({ duration:0 })
  React.useEffect(() => { 
    setTimeout(() => {
      setMotionTransition({ duration: 0.25, ease: 'easeInOut' })
    }, 1000);
  }, [])

  React.useEffect(() => { // ? Remove errors from login form, whenever step changes.
    methods.clearErrors()
  }, [step])

  return (
    <MainContainer
      customFlexDirection='column'
      isMobile={isMobile}
    >
      <LinkLogo className="position-absolute top-0 left-0 d-none d-md-block" />

      <StyledLogo
        className="d-xs-block d-md-none"
        rel="preload"
        src={ selectedProduct?.image_ads }
        customPosition={'static'}
        customHeight={80}
      />
      <Content
        customWidth='500px'
        isMobile={isMobile}
      >
        <SlideViewport>
          <SlideTrack
            // transition={{ duration: 0.25, ease: 'easeInOut' }}
            transition={motionTransition}
            slidesNumber={slidesNumber ? slidesNumber : ''}
            // animate={{ x: booleanStep ? '0' : '-50%' }}
            animate={{ x: `-${step*(100/slidesNumber)}%` }}
          >
            <SlidePanel>
              <AltClientEntity
                setStep={setStep}
                step={step}
              />
            </SlidePanel>
            <SlidePanel>
                <FormProvider { ...methods }>
                  <form
                    onSubmit={ handleSubmit(onSubmit) }
                  >
                    <h1 className="pb-4">{ t("login.login") }</h1>
                    <ControllerInput              
                      autoComplete="off"
                      disabled={ loading }
                      label={ t("common.username") }
                      message={ errors.username?.message }
                      name={ register("username").name }
                      control={methods?.control}              
                      type="text"
                      altErrorStyle={altErrorMessageStyle}
                      labelColor='white'
                    />
                    <ControllerInput
                      groupClassName='mb-4'
                      autoComplete="off"
                      disabled={ loading }
                      label={ t("common.password") }
                      message={ errors.password?.message }
                      name={ register("password").name }
                      control={methods?.control}              
                      type="password"
                      altErrorStyle={altErrorMessageStyle}
                      labelColor='white'
                    />
                    {!loading && (
                      
                      <div
                        style={{
                          cursor: 'pointer',
                          userSelect: 'none'
                        }}
                        onClick={onForgotPassword}
                      >
                        {/* <RouterLink
                          className="p-0 col-12"
                          color="third"
                          disabled={ loading }
                          to={ siteMap.recoverPasswordEmail.path }
                          name="link_recover_password"
                        > */}
                        { t("login.recoverPassword") }
                        {/* </RouterLink> */}
                      </div>
                    )}
                    {!loading && (
                      <div className="col-12">
                        {/* <RouterLink
                          className="p-0 col-12"
                          color="first"
                          disabled={ loading }
                          to={ siteMap.clientEntity.path }
                        > */}
                        <LinkText onClick={() => setStep(0) } color='third'>
                          { t("clientEntity.title") }
                        </LinkText>
                        {/* </RouterLink> */}
                      </div>
                    )}
                    {loading
                      ? (<LoaderSpinner />)
                      : (
                        <Button
                          className="btn"
                          color="first"
                          disabled={ loading }
                          type="submit"
                          name="btn_login"
                        >
                          { t("login.buttonLogIn") }
                        </Button>
                      )
                    }
                    {!loading && (
                      <Button
                        className="btn"
                        color="third"
                        disabled={ loading }
                        onClick={ onGetStarted }
                        type="button"
                        name="btn_sign_up"
                      >
                        { t("login.buttonSignUp") }
                      </Button>
                    )}
                    {!loading && (
                      <Label
                        disabled={ loading }
                        color='white'
                      >
                        { isUndefinedNull(geolocation) ? t("login.needGrantGeolocation") : t("login.allowedGeolocation") }
                      </Label>
                    )}
                    {!loading && isUndefinedNull(geolocation) && (
                      <Button
                        className="btn"
                        color="third"
                        disabled={ loading }
                        onClick={ activateLocation }
                        type="button"
                      >
                        <Link
                          className="btn"
                          color="fourth"
                          disabled={ loading }
                          title={ t("login.disabledLocation") }
                          type="button"
                        >
                          <FontAwesomeIcon color='#FFFFFF' icon={ faMapMarked } />
                        </Link>
                        <span
                          className='ms-2'
                          disabled={ loading }
                        >
                          { t("login.activateGeolocation") }
                        </span>
                      </Button>
                    )}
                  </form>
                </FormProvider>
            </SlidePanel>
            <SlidePanel>
              <AltRecoverPassword
                setStep={setStep}
              />
            </SlidePanel>
          </SlideTrack>
        </SlideViewport>
      </Content>
      <SlideCaptchaModal
        isOpen={ isSlideModalOpen }
        onRequestClose={ () => setIsSlideModalOpen(false) }
        onSuccess={() => handleOpen(values)}
      />
      <OtpInputModal 
        isOpen={isOpen}
        handleClose={handleClose}
        title={true}
        values={otpValues}
        attemps={attemps}
        setAttemps={setAttemps}
      />
    </MainContainer>
  )
}

export default AltLoginPage